var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 108,
    viewBox: "0 0 104 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.563 108L46.0376 63.6998L10.1341 88.8901L0 71.2279L40.2467 53.5657L0.289544 36.193L9.84451 19.1099L46.3271 44.3003L42.2735 0H61.9625L57.6193 44.3003L93.8124 19.1099L103.078 35.9035L63.1207 53.8552L103.367 71.5175L93.8124 88.6006L57.6193 63.6998L61.673 108H42.563Z",
    fill: "#7B46FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar04);
export default __webpack_public_path__ + "static/media/star-04.f82795f6b26b502edfefdbde95056f09.svg";
export { ForwardRef as ReactComponent };